import { INITIAL_EDITOR_VALUE } from 'src/components/RichTextEditor';

export enum FORM_VALUES {
  question = 'question',
  answer = 'answer',
}

export const DEFAULT_EDITOR_VALUE = JSON.stringify(INITIAL_EDITOR_VALUE);
